import { ExportButton } from "@/components/export/ExportButton";
import PageHeader from "@/components/PageHeader";
import Title from "@/components/Title";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
} from "@/components/ui/card";
import WeekFilter from "@/components/WeekFilter";
import { Module } from "@/constants";
import useUpdatesBreadcrumb from "@/modules/updates/hooks/useUpdatesBreadcrumb";
import { format } from "date-fns";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

const Updates = () => {
  const { t } = useTranslation();
  const breadcrumbItems = useUpdatesBreadcrumb();
  const [week, setWeek] = useState<Date>(new Date());

  const params = useMemo(() => {
    const searchParams = new URLSearchParams();
    searchParams.append("year", format(week, "R"));
    searchParams.append("iso_week", format(week, "I"));
    return searchParams;
  }, [week]);

  return (
    <div>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <Card>
        <CardHeader>
          <Title>{t("updates.peerWeek.title.long")}</Title>
          <CardDescription>{t("updates.peerWeek.description")}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-row gap-2 items-center">
            <WeekFilter value={week} onWeekChange={setWeek} />
            <ExportButton
              moduleName={Module.UpdatesPerWeek}
              queryParams={params}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Updates;
